<template lang="html">


 <section class="full-view-intro column-center" :launched="launched">
  
  <template v-if="isMovil != 'a'">
  <video controls="false" loop="true" muted="true" id="video-intro-home" autoplay="true" playsinline :launched="launched">
    <template v-if="!isMovil">
      <source src="/static/video/video-intro-home.mp4" type="video/mp4">
    </template>
    <template v-else>
      <source src="/static/video/video-intro-home-movil.mp4" playsinline type="video/mp4">
    </template>
    </video>
  </template>

    <router-link to="/" class="logo">
      <img src="/static/img/logo.png" alt="">
    </router-link>


    <div class="contenedor-caballero">

      <img src="/static/img/caballero-claro-small.png" width="51" class="imagen-caballero" alt="Caballero">

    </div>

    <h1 class="title -intro">
      <span>{{$t('home.intro.titulo_uno')}}</span>
      <span>{{$t('home.intro.titulo_dos')}}</span>
      <span>{{$t('home.intro.titulo_tres')}}</span>
    </h1>

    <h2 class="subtitle-intro">
      <span>{{$t('home.intro.experiencia_aldonza')}}</span>
    </h2>

    <div class="contenedor-boton">

      <button class="next to-home" @click="changeLaunched">{{$t('home.intro.aqui')}}</button>

    </div>

  </section>

</template>

<script lang="js">

  import {mapGetters,mapActions} from 'vuex';

  export default  {
    name: 'intro',
    data(){
      return{
        isMovil : 'a'
      }
    },
    mounted(){
      this.checkIsMovil();

      if(this.$route.name == 'newsletter'){
        this.changeLaunched();
      }

    },
    methods :{
      ...mapActions(['changeLaunched']),
      toDown : function(){
        $('html, body').animate({
          scrollTop: ($(window).height() / 2)
        },1000);
      },
      checkIsMovil : function(){
        this.isMovil = ($(window).width() < $(window).height());
      }
    },
    computed : {
      ...mapGetters({
        launched : 'isLaunchedHome'
      }),
      
    }
  }
</script>

<style scoped lang="scss">

  @import "@/assets/css/colors.scss";

  #video-intro-home{
    position: absolute;
    left: 50%;
    top: 50%;
    min-height: 100vh;
    min-width: 100vw;
    transform: translate(-50%,-50%);
    pointer-events: none;
  }

  .logo{
    position: absolute;
    right: 20px;
    top: 20px;
  }

  .full-view-intro{
    background: url("/static/img/intro-home.jpg") center/cover no-repeat;
    position: fixed;
    left: 0;
    top: 0;
    z-index:31;
    background-color: #000;
    
  }

  .full-view-intro::before,
  .full-view-intro::after{
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
    background: #000;
    display: inline-block;
    content: '';
    opacity: 0;
    pointer-events: none;
    transition: 1s;
    transition-delay: .5s;
  }


  .full-view-intro::after{
    opacity: 1;
    animation-name: showBlackCover;
    animation-delay:.5s;
    animation-duration:1s;
    animation-iteration-count: 1;
    -webkit-animation-fill-mode: forwards;
    -o-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
  }

  .intro-fake .full-view-intro::before,
  .intro-fake .full-view-intro::after{
    display: none;
  }

  @keyframes showBlackCover{
    to{
      opacity: 0;
    }
  }

  .full-view-intro[launched=true]{
    animation-name: ExitOfFullViewIntro;
    animation-delay:.5s;
    animation-duration:2s;
    animation-iteration-count: 1;
    -webkit-animation-fill-mode: forwards;
    -o-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
  }

  .intro-fake .full-view-intro[launched=true]{
    -webkit-animation-name: none;
    -o-animation-name: none;
    animation-name: none;
    position: relative;
  }

  @keyframes ExitOfFullViewIntro{
    99%{
      opacity: 0;
      transform: translateY(0%);
    }
    100%{
      transform: translateY(-100%);
      opacity: 0;
    }

  }

    #video-intro-home[launched=true]{
          animation-name: ExitOfVideo;
    animation-delay:.5s;
    animation-duration:1s;
    animation-iteration-count: 1;
    -webkit-animation-fill-mode: forwards;
    -o-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
    }

  @keyframes ExitOfVideo{
    
    to{
      opacity: 0;
    }

  }

  .full-view-intro[launched=true]::before{
    opacity: 1;
  }

  .contenedor-caballero{
    overflow: hidden;
    padding-bottom: 20px;
    display: inline-block;
    width: 100%;
  }

  .imagen-caballero{
    animation-name: showCaballero;
    animation-delay:.5s;
    animation-duration:.5s;
    animation-iteration-count: 1;
    -webkit-animation-fill-mode:forwards;
    -o-animation-fill-mode:forwards;
    animation-fill-mode:forwards;
    display: inline-block;
    opacity: 0;
  }

  @keyframes showCaballero{
    from{
      transform: translateY(150%);
      opacity: 0;
    }

    to{
      transform: translateY(0);
      opacity: 1;
    }
  }

  .subtitle-intro span{
    animation-name: showSubtitle;
    animation-delay:2s;
    animation-duration:1s;
    animation-iteration-count: 1;
    -webkit-animation-fill-mode:forwards;
    -o-animation-fill-mode:forwards;
    animation-fill-mode:forwards;
  }

  @keyframes showSubtitle{
    to{
      transform: translateY(0);
    }
  }

  .next{
    font-size: 24px;
    text-transform: uppercase;
    letter-spacing: 3px;
    margin-top: 40px;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background: transparent;
    border:1px solid white;
    position: relative;
    outline: none;
    cursor: pointer;
  }

  .next.to-down{
    display: none;
  }

  .intro-fake .next.to-down{
    display: inline-block;
  }


  .intro-fake .subtitle-intro{
    display: none;
  }

  @keyframes showNext{

    to{
      opacity: 1;
      transform: translateY(0);
    }

  }

  .next::before,
  .next::after{
    width: 140px;
    height: 140px;
    border: 1px solid $white-50;
    content: '';
    display: inline-block;
    position: absolute;
    left: -22px;
    top: -22px;
    border-radius: 50%;
    transition: .6s;
    transform: scale(.70);
    animation-duration:1.5s;
    opacity: 0;
    animation-name: circleAnimation;
    animation-iteration-count: infinite;
  }

  .next::before{
    animation-delay: 2s;
  }

  .next::after{
    animation-delay: 2.5s;
  }

  [launched=true] .next.to-home{
    animation-duration:6s;
    animation-name: nextAnimation;
    -webkit-animation-fill-mode: forwards;
    -o-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
  }

  @keyframes nextAnimation{
    80%{
      -webkit-transform: perspective(100px) translate3d(20px, 0px, 3000px);
      -moz-transform: perspective(100px) translate3d(20px, 0px, 3000px);
      -o-transform: perspective(100px) translate3d(20px, 0px, 3000px);
      -ms-transform: perspective(100px) translate3d(20px, 0px, 3000px);
      transform: perspective(100px) translate3d(20px, 0px, 3000px);
      pointer-events: none;
      background: #000;
    }
    100%{
      opacity: 0;
      background: #000;
    }
  }

  .intro-fake{
    .full-view-intro{
      position: relative;
      left: auto;
      top: auto;
      opacity: 1;
      z-index: 10;
      animation-name: none;
      height: 50vh;
    }

    .next.to-home{
      display: none;
    }

    .logo{
      display: none;
    }

  }
  
  .contenedor-boton{
    opacity: 0;
    transform: translateY(100px) scale(.8);
    animation-duration:2s;
    animation-name: showButton;
    animation-delay: 3s;
    -webkit-animation-fill-mode: forwards;
    -o-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
  }


  @keyframes showButton{
    100%{
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media screen and (max-width: 767px){
    .title.-intro{
      height: 80px;
      span{
        transform: translateY(-200%);
        height: 40px;
      }
    }
  }




</style>



// WEBPACK FOOTER //
// src/components/views/home/intro-home.vue